import { PluginKey } from "@tiptap/pm/state";
import { Decoration, DecorationSet } from "@tiptap/pm/view";
import { OrderedSet } from "immutable";
import { Plugin } from "prosemirror-state";
import colorDataDefaults from "./../ricos-schema/legacy/statics/color.defaults.json.js";
import { Mark_Type } from "./../ricos-types/index.js";
import { createRicosMarkExtension } from "./../plugin-commons/index.js";
import { FOREGROUND_COLOR } from "./data-hooks.js";
const COLOR_PREVIEW_PLUGIN_KEY = new PluginKey("colorPreview");
const tiptapColorForegroundExtension = createRicosMarkExtension({
  type: "mark",
  name: Mark_Type.COLOR_FOREGROUND,
  groups: [],
  reconfigure: (config, _extensions, _props, settings) => ({
    ...config,
    addOptions() {
      return {
        HTMLAttributes: {},
        ...settings
      };
    }
  }),
  createExtensionConfig() {
    return {
      name: this.name,
      addAttributes() {
        return {
          color: { default: colorDataDefaults.foreground }
        };
      },
      parseHTML() {
        return [
          {
            style: "color",
            getAttrs: (color) => ({ color })
          }
        ];
      },
      renderHTML({ HTMLAttributes: { color } }) {
        const styleColor = this.options.styleSelectionPredicate?.(color) ? this.options.customStyleFn?.(OrderedSet([color])).color : color;
        return [
          "span",
          {
            "data-hook": FOREGROUND_COLOR,
            style: `color: ${styleColor}; text-decoration: inherit;`
          }
        ];
      },
      addCommands() {
        return {
          previewColor: (color) => ({ tr, dispatch }) => {
            tr.setMeta(COLOR_PREVIEW_PLUGIN_KEY, color);
            dispatch?.(tr);
            return true;
          },
          setColor: (color) => ({ tr, dispatch, commands }) => {
            commands.setMark(this.name, { color });
            tr.setMeta(COLOR_PREVIEW_PLUGIN_KEY, null);
            dispatch?.(tr);
            return true;
          },
          unsetColor: () => ({ commands }) => commands.setMark(this.name, { color: null })
        };
      },
      addProseMirrorPlugins() {
        return [
          new Plugin({
            key: COLOR_PREVIEW_PLUGIN_KEY,
            state: {
              init() {
                return { color: null };
              },
              apply(tr) {
                const newColor = tr.getMeta(COLOR_PREVIEW_PLUGIN_KEY);
                return { color: newColor };
              }
            },
            props: {
              decorations(state) {
                const { color } = COLOR_PREVIEW_PLUGIN_KEY.getState(state);
                const { from, to } = state.selection;
                if (!color || from === to) {
                  return null;
                }
                return DecorationSet.create(state.doc, [
                  Decoration.inline(from, to, {
                    style: `color: ${color}; text-decoration: inherit;`
                  })
                ]);
              }
            }
          })
        ];
      }
    };
  }
});
export {
  tiptapColorForegroundExtension
};
//# sourceMappingURL=tiptap-foreground.js.map
